import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.search";
import r from "@babel/runtime/regenerator";
import n from "@babel/runtime/helpers/slicedToArray";
import e from "@babel/runtime/helpers/asyncToGenerator";
import { useState as t, useEffect as o, useRef as i, useCallback as a, useMemo as c } from "react";
import { globalHistory as u } from "@reach/router";
import { chunk as l } from "tiny-compose-fns/noFp";
import { isBrowser as s } from "@walltowall/helpers";
import { isBrowser as f } from "helpers";

var d = function d(r, n, e) {
  var t = Boolean(document.getElementById(r));

  if (!t) {
    var o = document.createElement("script");
    o.src = n, o.id = r, document.body.appendChild(o), e && (o.onload = e);
  }

  t && e && e();
},
    m = function () {
  var i = e(r.mark(function e(i, a, c) {
    var u, l, s, f;
    return r.wrap(function (r) {
      for (;;) {
        switch (r.prev = r.next) {
          case 0:
            return u = t(!1), l = n(u, 2), s = l[0], f = l[1], r.next = 3, o(function () {
              s || (d(i, a, c), f(!0));
            }, [c, i, s, a]);

          case 3:
            return r.abrupt("return", s);

          case 4:
          case "end":
            return r.stop();
        }
      }
    }, e);
  }));
  return function (r, n, e) {
    return i.apply(this, arguments);
  };
}(),
    v = function v(r, n) {
  var e = i(),
      t = i(!0),
      c = i(),
      u = i(),
      l = i(),
      s = a(function (r) {
    var o;
    u.current = null !== (o = u.current) && void 0 !== o ? o : r, l.current = r - u.current, t.current && l.current >= n && (u.current = r, e.current(r)), c.current = requestAnimationFrame(s);
  }, [n]);
  return o(function () {
    e.current = r;
  }, [r]), o(function () {
    return c.current = requestAnimationFrame(s), function () {
      return cancelAnimationFrame(c.current);
    };
  }, [n, s]), {
    start: function start() {
      t.current = !0, u.current = null, c.current = requestAnimationFrame(s);
    },
    stop: function stop() {
      t.current = !1, cancelAnimationFrame(c.current);
    },
    pause: function pause() {
      t.current = !1;
    }
  };
},
    h = function h(r, n) {
  var e = a(function (e) {
    e.key === r && n();
  }, [n, r]);
  o(function () {
    return window.addEventListener("keydown", e), function () {
      window.removeEventListener("keydown", e);
    };
  }, [e]);
},
    p = function p() {
  var r = t(u.location),
      e = n(r, 2),
      i = e[0],
      a = e[1];
  return o(function () {
    var r = u.listen(function (r) {
      var n = r.location;
      a(n);
    });
    return function () {
      return [r()];
    };
  }, []), i;
},
    w = function w(r) {
  var e = r.collection,
      i = r.perPage,
      u = void 0 === i ? 20 : i,
      f = r.initialPage,
      d = void 0 === f ? 0 : f,
      m = r.containerRef,
      v = r.paramKey,
      h = void 0 === v ? "page" : v,
      p = t(function () {
    if (!s) return d;
    var r = new URLSearchParams(location.search).get(h);
    return r ? r - 1 : d;
  }),
      w = n(p, 2),
      g = w[0],
      P = w[1],
      y = c(function () {
    return l(u, e);
  }, [u, e]),
      b = y[g] || [],
      L = y.length,
      S = a(function (r) {
    var n = new URLSearchParams(location.search);
    n.set(h, r + 1), history.replaceState(null, "", "".concat(window.location.pathname, "?").concat(n.toString())), P(r);
  }, [h]),
      R = a(function () {
    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
    return S(Math.min(g + r, L - 1));
  }, [g, S, L]),
      U = a(function () {
    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
    return S(Math.max(g - r, 0));
  }, [g, S]);
  return o(function () {
    var r = null == m ? void 0 : m.current;
    r && new URLSearchParams(location.search).get(h) && r.scrollIntoView({
      behavior: "smooth"
    });
  }, [m, g, h]), {
    paginatedCollection: b,
    page: g,
    totalPages: L,
    hasNextPage: g + 1 < L,
    hasPreviousPage: g > 0,
    incPage: R,
    decPage: U,
    setPage: S
  };
},
    g = "undefined" != typeof window,
    P = function P(r, n) {
  return r === n ? 0 : r > n ? 1 : -1;
},
    y = function y() {
  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
      e = i(g ? window.scrollY : 0),
      c = i(g ? window.scrollY : 0),
      u = t(0),
      l = n(u, 2),
      s = l[0],
      f = l[1],
      d = a(function () {
    if (!(Math.abs(window.scrollY - c.current) < r)) {
      e.current = c.current, c.current = window.scrollY;
      var n = P(c.current, e.current);
      0 !== n && n !== s && f(n);
    }
  }, [s, r]);
  return o(function () {
    return window.addEventListener("scroll", d, {
      passive: !0
    }), function () {
      return window.removeEventListener("scroll", d, {
        passive: !0
      });
    };
  }, [d]), {
    direction: s,
    isScrollingDown: 1 === s,
    isScrollingUp: -1 === s
  };
},
    b = function b(r, e) {
  var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : f ? window.location : {},
      a = t(function () {
    var n;
    return null !== (n = new URLSearchParams(i.href).get(r)) && void 0 !== n ? n : e;
  }),
      u = n(a, 2),
      l = u[0],
      s = u[1];
  return o(function () {
    if (f) {
      var n = new URL(i.href),
          t = null != l ? l : e;
      return (null == t ? void 0 : t.length) > 0 ? n.searchParams.set(r, l) : n.searchParams["delete"](r), history.replaceState(void 0, void 0, n.href), function () {
        var n = new URL(i.href);
        n.searchParams["delete"](r), history.replaceState(void 0, void 0, n.href);
      };
    }
  }, [l, r, e, i.href]), c(function () {
    return [l, s];
  }, [l]);
};

export { m as useDynamicScript, v as useInterval, h as useKeyPress, p as useLocation, w as usePaginatedCollection, y as useScrollDirection, b as useURLSearchParam };